import { each, every, last, isEmpty as lodashIsEmpty, map, sortBy } from 'lodash';
import { type } from '@mews-framework/utils';
import Interval from './Interval';

export default {
    addSet,
    addInterval,
    isEmpty,
    toArray,
    fromArray,
};

function addSet(add = [], set = []) {
    let newSet = set;

    each(add, (i) => {
        // @ts-expect-error $TSFixMeError: Type '(number | ((...items: never[]) => number) | (() => string) | (() => IterableIterator<never>) | (() => { copyWithin...
        newSet = addInterval(i, newSet);
    });

    return newSet;
}

function addInterval(interval: $TSFixMe, set = []) {
    type.check(set, Array);
    Interval.is(interval);
    // @ts-expect-error $TSFixMeError: Argument of type 'any' is not assignable to parameter of type 'never'.
    set.push(interval);

    const sorted = sortBy(set, (i) => (i as $TSFixMe).low);
    const newSet = [sorted[0]];

    each(sorted, (i) => {
        const top = last(newSet);

        if (Interval.collides(i, top)) {
            // @ts-expect-error $TSFixMeError: Type '{ high: null | undefined; low: null | undefined; }' is not assignable to type 'number | (() => IterableIterator<never>)
            newSet[newSet.length - 1] = Interval.union(i, top);
        } else {
            newSet.push(i);
        }
    });

    return newSet;
}

function isEmpty(set = []) {
    return lodashIsEmpty(set) || every(set, (i) => Interval.isEmpty(i));
}

function toArray(set: $TSFixMe) {
    return map(set, (interval) => ({ high: interval.high, low: interval.low }));
}

function fromArray(array: $TSFixMe) {
    return map(array, Interval.create);
}
